import { useContext } from "react";
import { AppContext } from "../App";
import { getServiceCategory, serviceCategories } from "./ServicesContent";

export default function ServiceDetailContent(props) {
  const { serviceSlug } = props;
  const appContext = useContext(AppContext);
  const service = getServiceCategory(serviceSlug);

  if (!service) {
    return (
      <section className="vex-section vex-section-light">
        <div className="container">
          <div className="vex-content-panel">
            <h2>Service category not found.</h2>
            <p>The selected service page could not be loaded.</p>
            <button
              type="button"
              className="btn btn-primary vex-btn"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              Back To Services
            </button>
          </div>
        </div>
      </section>
    );
  }

  const relatedServices = serviceCategories.filter(
    (item) => item.slug !== serviceSlug,
  );

  return (
    <>
      <section className="vex-detail-hero" data-aos="fade-up">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="vex-detail-copy">
                <button
                  type="button"
                  className="vex-back-link"
                  onClick={() => appContext.navTo({ item: "services" })}
                >
                  Back to all services
                </button>
                <p className="vex-eyebrow">{service.navTitle}</p>
                <h1>{service.title}</h1>
                <p>{service.intro}</p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
              <div className="vex-detail-image">
                <img src={service.heroImage} alt={service.title} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vex-section vex-section-light" data-aos="fade-up">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-8" data-aos="fade-right">
              <div className="vex-content-panel vex-content-panel-tall">
                <p className="vex-panel-tag">Category Overview</p>
                <h2>{service.summary}</h2>
                <p>{service.body}</p>
              </div>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <div className="vex-content-panel vex-content-panel-dark">
                <p className="vex-panel-tag vex-panel-tag-light">
                  What We Cover
                </p>
                <div className="vex-side-list">
                  {service.highlights.map((highlight) => (
                    <div key={highlight}>{highlight}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="vex-products-grid">
            {service.products.map((product, index) => (
              <article
                key={product.title}
                className="vex-product-card"
                data-aos="fade-up"
                data-aos-delay={(index % 3) * 70}
              >
                <div className="vex-product-card-media">
                  <img src={product.image} alt={product.title} />
                </div>
                <div className="vex-product-card-body">
                  <p className="vex-panel-tag">{service.navTitle}</p>
                  <h3>{product.title}</h3>
                  <p>{product.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="vex-section" data-aos="fade-up">
        <div className="container">
          <div className="vex-section-heading" data-aos="fade-up">
            <p className="vex-panel-tag">Related Categories</p>
            <h2>Explore other VEX supply categories.</h2>
          </div>

          <div className="vex-related-grid">
            {relatedServices.map((item, index) => (
              <div
                key={item.slug}
                className="vex-related-card"
                data-aos="fade-up"
                data-aos-delay={index * 80}
                onClick={() =>
                  appContext.navTo({ item: "services", subItem: item.slug })
                }
                role="button"
                tabIndex={0}
              >
                <img src={item.heroImage} alt={item.title} />
                <div>
                  <p className="vex-panel-tag">{item.navTitle}</p>
                  <h3>{item.title}</h3>
                  <p>{item.summary}</p>
                  <button
                    type="button"
                    className="btn btn-link vex-inline-link"
                    onClick={(event) => {
                      event.stopPropagation();
                      appContext.navTo({
                        item: "services",
                        subItem: item.slug,
                      });
                    }}
                  >
                    Open Category
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
